<script lang="ts">
    import { _ } from "svelte-i18n"
    import FormInputCheckbox from "../../widgets/Form/FormInputCheckbox.svelte"
    import { overlay, staticFrontendLinks } from "../../../store"
    import { initialLocale } from "../../../i18n"
    let {
        cancellationNotice = $bindable(false),
        privacyNotice = $bindable(false),
        conditionsNotice = $bindable(false),
    } = $props()
</script>

<FormInputCheckbox label="" bind:checked={cancellationNotice}>
    {@html $_("inquiry.i-have-the")}
    <a
        href="/de/service/widerruf"
        onclick={(e) => {
            e.preventDefault()
            $overlay = {
                show: true,
                type: "content",
                properties: {
                    // @ts-ignore
                    pageToRender: $staticFrontendLinks["cancellationPolicy"][initialLocale],
                },
            }
        }}
    >
        {@html $_("checkout.right-of-withdrawal")}
    </a>
    {@html $_("checkout.dataprotection-note")}
</FormInputCheckbox>
<FormInputCheckbox label="" bind:checked={privacyNotice}>
    {@html $_("inquiry.i-have-the")}
    <a
        href="/de/service/datenschutz"
        onclick={(e) => {
            e.preventDefault()
            $overlay = {
                show: true,
                type: "content",
                properties: {
                    // @ts-ignore
                    pageToRender: $staticFrontendLinks["dataProtection"][initialLocale],
                },
            }
        }}
    >
        {@html $_("checkout.dataprotection")}
    </a>
    {@html $_("checkout.dataprotection-note")}
</FormInputCheckbox>
<FormInputCheckbox label="" bind:checked={conditionsNotice}>
    {@html $_("inquiry.i-have-the")}
    <a
        href="/de/service/agb"
        onclick={(e) => {
            e.preventDefault()
            $overlay = {
                show: true,
                type: "content",
                properties: {
                    // @ts-ignore
                    pageToRender: $staticFrontendLinks["termsAndConditions"][initialLocale],
                },
            }
        }}
    >
        {@html $_("checkout.general-terms")}
    </a>
    {@html $_("checkout.dataprotection-note")}
</FormInputCheckbox>
